<script>
import { mapGetters } from 'vuex';
import { iconLoader } from '@/helpers/iconsLoader';
import {SafeAwait} from "@/core/util/SafeAwait";

const defaultProps = {
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  itemText: {
    type: String,
    required: false,
    default: 'name',
  },
  isClearable: {
    type: Boolean,
    required: false,
    default: false,
  }
}

export default {
  name: "GlobalAccountSelector",
  components: {
    ...iconLoader.sideMenu
  },
  props: defaultProps,
  data: () => ({
    search: '',
    accountsSearchQuery: {
      page: 0,
      maxPerPage: 10,
      sort: 'name'
    },
  }),
  computed: {
    ...mapGetters({
      accountsList: 'accountsApiStore/accountsList',
      globalAccount: 'accountsApiStore/accountSelected',
      accountsLoading: 'accountsApiStore/accountsLoading',
      userRoles: 'users/getUserRole'
    }),
  },
  methods: {
    async onAccountChange(account) {
      if (!account) {
        this.$store.commit('accountsApiStore/setSelectedAccount', null);
        return;
      }

      const { id } = account;
      this.$store.commit('accountsApiStore/setSelectedAccount', id);

      if (this.accountsSearchQuery.name) {
        this.search = '';
        this.accountsSearchQuery.name = undefined;
        await this.onLoadAccountsList();

        this.$store.commit('accountsApiStore/setAccounts', [account, ...this.accountsList]);
      }
    },
    async onSearchQuery(input) {
      if (!input) {
        this.search = '';
        this.accountsSearchQuery.name = undefined;

        return await this.onLoadAccountsList();
      }

      if (input && input.length >= 3) {
        this.search = input;

        this.accountsSearchQuery.name = this.search;
        await this.onLoadAccountsList();
      }
    },
    async onLoadAccountsList() {
      const { result, error } = await SafeAwait.execute(async () => {
        return await this.$store.dispatch('accountsApiStore/fetchAccountsList', this.accountsSearchQuery);
      });

      if (error) {
        // this.$store.commit('notificationStore/addError', error);
      }

      this.$store.commit('accountsApiStore/setAccounts', [...result.data]);
    },
    async onFetchAccountById(id) {
      const { result, error } = await SafeAwait.execute(async () => {
        return await this.$store.dispatch('accountsApiStore/fetchAccountById', id);
      });

      if (error) {
        // this.$store.commit('notificationStore/addError', error);
      }

      if (result.data) {
        this.$store.commit('accountsApiStore/setAccounts', [result.data, ...this.accountsList]);
        this.$store.commit('accountsApiStore/setSelectedAccount', id);
      } else {
        this.$store.commit('accountsApiStore/setSelectedAccount', this.accountsList[0].id);
      }

    }
  },
  async mounted() {
    if (this.accountsList.length > 0) return;
    await this.onLoadAccountsList();

    const localAccountId = localStorage.getItem('account_id');

    if (localAccountId && localAccountId !== 'null') {
      this.onFetchAccountById(localAccountId);
    } else {
      this.$store.commit('accountsApiStore/setSelectedAccount', this.accountsList[0].id);
    }
  }
}
</script>

<template>
  <v-select
    :items="accountsList"
    :value="globalAccount"
    class="bs-search-item"
    item-value="id"
    item-text="name"
    outlined
    hide-details
    dense
    return-object
    height="44"
    :clearable="isClearable"
    :menu-props="{ nudgeBottom: 45 }"
    :placeholder="$t('components.corporationSelect.selectCorporation')"
    @change="onAccountChange"
  >
    <template v-slot:prepend-inner>
      <department-icon />
    </template>

    <template v-slot:prepend-item>
      <v-text-field
        :value="search"
        :placeholder="$t('components.corporationSelect.searchAccounts')"
        dense
        outlined
        class="px-3 py-2"
        hide-details
        clearable
        @click.stop
        @input="onSearchQuery"
      ></v-text-field>
    </template>
  </v-select>
</template>

<style scoped lang="scss">

</style>
